module.exports = __webpack_public_path__ + "img/202306_08.27bf0dae.jpg";